import { render, staticRenderFns } from "./localLife.vue?vue&type=template&id=503d456b&scoped=true"
import script from "./localLife.vue?vue&type=script&lang=js"
export * from "./localLife.vue?vue&type=script&lang=js"
import style0 from "./localLife.vue?vue&type=style&index=0&id=503d456b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503d456b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('503d456b')) {
      api.createRecord('503d456b', component.options)
    } else {
      api.reload('503d456b', component.options)
    }
    module.hot.accept("./localLife.vue?vue&type=template&id=503d456b&scoped=true", function () {
      api.rerender('503d456b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/localLife.vue"
export default component.exports